import { ThemeProvider } from '@mui/material';
import { defaultTheme } from '../../components/shared/ui-extension';
import { Item } from '../../components/item-v2/item';

const ItemPage = () => {
  return (
    <ThemeProvider theme={defaultTheme}>
      <Item />
    </ThemeProvider>
  );
};

export default ItemPage;
